'use client';

import { Icon } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';

import { Badge } from './badge';

export const Bento = () => {
  const t = useTranslations('landing.polyseme.benefits.bento');

  return (
    <div className="grid h-[1000px] auto-rows-fr grid-cols-1 gap-4 sm:h-[700px] sm:grid-cols-2 sm:grid-rows-6 lg:h-[440px] lg:grid-cols-3 lg:grid-rows-12">
      <div className="order-1 row-span-1 flex items-center justify-center gap-2 rounded-3xl bg-gray-100 p-4 sm:col-span-2 sm:row-span-1 lg:col-span-1 lg:row-span-3">
        <Image
          alt=""
          height={24}
          src={images.polyseme['logo-icon']}
          width={24}
        />
        <Image
          alt=""
          height={24}
          src={images.polyseme['logo-text']}
          width={130}
        />
      </div>

      <div className="order-3 row-span-2 flex flex-col items-start gap-2.5 rounded-3xl bg-gray-100 p-5 sm:col-span-1 sm:row-span-2 lg:order-2 lg:col-span-1 lg:row-span-6">
        <p className="text-xl leading-tight">{t('tracking.title')}</p>
        <Badge className="mt-auto bg-white" size="lg" variant="secondary">
          {t('tracking.badges.fileStatus')}
        </Badge>
        <Badge className="bg-white" size="lg" variant="secondary">
          {t('tracking.badges.clientReminder')}
        </Badge>
      </div>

      <div className="relative order-6 row-span-2 flex flex-col-reverse overflow-hidden rounded-3xl p-5 text-white sm:col-span-1 sm:row-span-2 lg:order-3 lg:col-span-1 lg:row-span-9">
        <Image
          fill
          alt=""
          className="object-cover brightness-50"
          src={images.polyseme.bento['2']}
        />
        <p className="relative z-10 text-xl">{t('b2b')}</p>
      </div>

      <div className="relative order-2 row-span-2 overflow-hidden rounded-3xl p-5 text-white sm:col-span-1 sm:row-span-2 lg:order-4 lg:col-span-1 lg:row-span-9">
        <Image
          fill
          alt=""
          className="object-cover brightness-50"
          src={images.polyseme.bento['1']}
        />
        <p className="relative z-10 text-xl">{t('digital')}</p>
      </div>

      <div className="order-5 row-span-2 flex flex-col justify-between rounded-3xl bg-gray-100 p-5 sm:col-span-1 sm:row-span-2 lg:order-5 lg:col-span-1 lg:row-span-6">
        <p className="text-xl">{t('signature')}</p>
        <div className="flex items-center justify-center rounded-xl bg-white p-5">
          <Image
            alt=""
            height={40}
            src={images.polyseme.bento['3']}
            width={140}
          />
        </div>
      </div>

      <div className="order-4 row-span-1 flex items-center rounded-3xl bg-gray-100 p-5 sm:col-span-2 sm:row-span-1 lg:order-6 lg:col-span-1 lg:row-span-3">
        <p className="text-xl">{t('api')}</p>
        <div className="ml-auto rounded-lg bg-white p-3.5">
          <Icon className="size-6" name="cloud-cog" />
        </div>
      </div>
    </div>
  );
};
